module.exports = __webpack_public_path__ + "img/drew-1.d3850482.jpg";